import React, { useState, useEffect } from 'react'
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.min.css";
import useReduxState from 'src/hooks/useReduxState';
import moment from 'moment';
import { startOfDay, endOfDay, subMonths, subDays } from 'date-fns';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';

const OrderHistoryDateFilter = () => {
    const [__check] = useAxiosIndicatorCheck();

    const [dateRange, setDateRange] = useReduxState('', 'setDateRange');
    const [selectedDateText, setSelectedDateText] = useState('Past 30 days');
    const [dateRangeSelectedPredefined, set_dateRangeSelectedPredefined] = useState('Past 30 days');
    const [dateRangeObject, set_dateRangeObject] = useState([startOfDay(subDays(new Date(), 29)), endOfDay(new Date())]);
    const [continuationToken, setContinuationToken] = useReduxState('', 'setContinuationToken');
    const { storageName: { ORDER_PAGE_TOKEN, ORDER_PAGE_COUNT } } = System

    useEffect(() => {
        if (dateRangeObject[0] !== null) {
            setDateRange(setDateForFilter(dateRangeObject));
            setContinuationToken(null)
            localStorage.removeItem(ORDER_PAGE_TOKEN)
        }
    }, [dateRangeObject])

    const setDateForFilter = (dtObj) => {
        let dt1_frm = moment(dtObj[0]).local().format("YYYYMMDD");
        let dt2_frm = moment(dtObj[1]).local().format("YYYYMMDD");
        let _dt = dt1_frm + ';' + dt2_frm;
        return _dt;
    }

    const Ranges = [
        {
          key: 'Day15',
          label: 'Past 15 days',
          slug: 'Past 15 days',
          value: [startOfDay(subDays(new Date(), 14)), endOfDay(new Date())],
          placement: 'left'
        },
        {
          key: 'Day30',
          label: 'Past 30 days',
          slug: 'Past 30 days',
          value: [startOfDay(subDays(new Date(), 29)), endOfDay(new Date())],
          placement: 'left'
          
        },
        {
          key: 'Month6',
          label: 'Past 6 months',
          slug: 'Past 6 months',
          value: [startOfDay(subMonths(new Date(), 6)), endOfDay(new Date())],
          placement: 'left'
        },
        {
          key: 'Month12',
          label: 'Past 12 months',
          slug: 'Past 12 months',
          value: [startOfDay(subMonths(new Date(), 12)), endOfDay(new Date())],
          placement: 'left'
        },
        {
            key: 'justBottomLabel',
            label: 'Select range by clicking on the dates.',
            value: "",
            placement: 'bottom'
        }
      ];
    return (
        <>
            <div className='see-orders m-b-10'>
                See <b>{!__check(['ORDER_API_CALL']).status && (localStorage.getItem(ORDER_PAGE_COUNT) || 0)}</b> orders from:
                <b> {selectedDateText}</b>
            </div>
            <div className='filer-by-date d-flex align-items-center m-b-20'>
                <span className='d-inline-block'>Filter by date or time period:</span>

                <a className="text-blue2 order-date-range-filter ms-2" id='order-date-range-filter'>
                    <DateRangePicker 
                        style={{ width: '100% !important' }}
                        appearance="subtle" 
                        placeholder="Select Range"
                        onChange={(dates, event) => {
                            set_dateRangeObject(dates);
                            $('.rs-picker-daterange-predefined').find('button').removeClass('selected');
                            if(event.target.getAttribute('slug')) {
                                setSelectedDateText(event.target.getAttribute('slug'));
                                set_dateRangeSelectedPredefined(event.target.getAttribute('slug'));
                                $('.rs-picker-daterange-predefined').find('button[slug="'+event.target.getAttribute('slug')+'"]').addClass('selected');
                            } else {
                                setSelectedDateText((moment(dates[0]).format(Helper.getDatepickerFormat().toUpperCase()) +' - '+ moment(dates[1]).format(Helper.getDatepickerFormat().toUpperCase())));
                                set_dateRangeSelectedPredefined('');
                            }
                          }}
                        onEnter={()=>{
                            $('.rs-picker-daterange-predefined').find('button').removeClass('selected');
                            if(dateRangeSelectedPredefined && dateRangeSelectedPredefined.trim() != "") {
                                $('.rs-picker-daterange-predefined').find('button[slug="'+dateRangeSelectedPredefined+'"]').addClass('selected');
                            }
                        }}
                        value={dateRangeObject} 
                        character=" - "
                        cleanable={false}
                        format={Helper.getDatepickerFormat()}
                        ranges={Ranges}
                        editable={false}
                    />
                </a>

            </div>
        </>
    )
}

export default OrderHistoryDateFilter